
import { Theme } from '@mui/material/styles';
import { Bookmaker } from 'smartstream-widgets/types/sharedModule/core'

export function getBookmakerLogoUrlByTheme(bookmaker: Bookmaker, theme: Theme) {
  const { palette: { mode } } = theme
  const logo = bookmaker && bookmaker.logo

  return logo && logo[mode] && logo[mode].svg
}

export function getBookmakerIconUrlByTheme(bookmaker: Bookmaker, theme: Theme) {
  const { palette: { mode } } = theme
  const logo = bookmaker && bookmaker.logo

  return logo && logo[mode] && logo[mode].icon
}

export function getBookmakerLogoUrlByType(basePath: string, sourceId: string, type: string) {
  return `${basePath}/img/bookmaker-logos/${sourceId}${type !== '' ? '-' : ''}${type}.svg`
}
